import { render } from "./manage-queue-dropdown.vue?vue&type=template&id=46a434ed&lang=pug"
import script from "./manage-queue-dropdown.vue?vue&type=script&lang=js"
export * from "./manage-queue-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__